import { useQuery } from '@tanstack/react-query';

/**
 * Probes a static legal PDF (eIFU, DoC) before embedding it: a missing
 * artifact would otherwise surface as a raw browser error pane inside the
 * iframe, or as an SPA-fallback rewrite pretending to be the document. The
 * content-type guard catches the rewrite case (index.html is text/html).
 */
async function probePdf(url: string): Promise<boolean> {
    try {
        const response = await fetch(url, { method: 'HEAD' });
        return response.ok && (response.headers.get('content-type') ?? '').includes('pdf');
    } catch {
        return false;
    }
}

/** `data` is `true` (embeddable), `false` (unavailable) or `undefined` (probing). */
export function usePdfAvailability(url: string) {
    return useQuery({
        queryKey: ['legal-pdf-availability', url],
        queryFn: () => probePdf(url),
        // Static assets are immutable per deployment — never goes stale in-session.
        staleTime: Infinity,
    });
}
